var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#E53E3E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3224_8084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7502 3.99996C10.0019 3.99996 9.39307 4.60877 9.39307 5.35708V10.6419C9.39307 11.3902 10.0019 11.999 10.7502 11.999C11.4985 11.999 12.1073 11.3902 12.1073 10.6419V5.35708C12.1073 4.60877 11.4985 3.99996 10.7502 3.99996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7502 13.2857C10.0019 13.2857 9.39307 13.8945 9.39307 14.6429C9.39307 15.3912 10.0019 16 10.7502 16C11.4985 16 12.1073 15.3912 12.1073 14.6429C12.1073 13.8945 11.4985 13.2857 10.7502 13.2857Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3224_8084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4.75 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/ExclamationMark.87ff43c23502eaf05ded96704dc99d95.svg";
export { ForwardRef as ReactComponent };